import io from 'socket.io-client'

export const SOCKET_INIT_STATE = 'SOCKET_INIT_STATE'

let socket

export const initWS = (link, port) => {
	return socket = io.connect(link + ':' + port,
		{ 'forceNew': true, 'reconnectInterval': 4000 })
}

export const getSocket = () => socket

export const initConnectWS = (state) => {
	return ({
		payload: state,
		type: SOCKET_INIT_STATE
	})
}


